import { TransparentButton, Typography } from '@libs/components';
import { hexColorWithOpacity } from '@libs/helpers';

import { BigDropdownIcon } from 'src/assets';

import styled from 'styled-components';

type ActionButtonProps = {
  disabled?: boolean;
  isLarge?: boolean;
};
export const ActionButtonContainer = styled(
  TransparentButton
)<ActionButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme, isLarge }) =>
    isLarge ? theme.borderRadius.x5 : theme.borderRadius.x4};
  padding: 1.6rem;
  width: 100%;
  position: relative;
`;

export const ActionButtonWrapper = styled.div<ActionButtonProps>`
  display: flex;
  align-items: ${({ isLarge }) => (isLarge ? 'flex-start' : 'center')};
  flex-direction: ${({ isLarge }) => (isLarge ? 'column' : 'row')};
  width: 100%;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  padding: 1rem;
  background-color: ${({ theme }) =>
    hexColorWithOpacity(theme.colors.borders.highlight, 8)};
  margin-right: 1.2rem;
`;

export const ArrowIcon = styled(BigDropdownIcon)<ActionButtonProps>`
  margin-left: 1rem;
  width: ${({ isLarge }) => (isLarge ? '1.4rem' : '1.1rem')};
  height: ${({ isLarge }) => (isLarge ? '1.4rem' : '1.1rem')};
  opacity: ${({ disabled }) => (disabled ? '50%' : '100%')};
`;

export const TextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 0.4rem;
`;
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CustomTypography = styled(Typography)<ActionButtonProps>`
  opacity: ${({ disabled }) => (disabled ? '50%' : '100%')};
  text-align: start;
`;

export const IconRightComponentWrapper = styled.div<ActionButtonProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: ${({ disabled }) => (disabled ? '50%' : '100%')};
  margin-bottom: ${({ isLarge }) => (isLarge ? '2rem' : 0)};
  width: ${({ isLarge }) => (isLarge ? '100%' : 'unset')};
`;
export const Img = styled.img`
  width: 3.2rem;
  height: 3.2rem;
`;

export const RightCornerTextWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.2rem 0.8rem;
  background-color: ${({ theme }) => theme.colors.borders.highlight};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.x3};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const Notice = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.rejectedBackground};
  color: ${({ theme }) => theme.colors.text.critical};
  padding: 0.3rem 0.4rem;
`;

export const BalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-start;
  ${({ theme }) => theme.media.tablet`
      flex-direction:row;
  `};
`;
